export const trackButtonClick = (selectedItems, header) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'page_controls',
      'eventCategory': 'questions_answers',
      'content_title': header,
      'eventAction': 'click',
      'eventLabel': selectedItems.toString(),
    });
  };